/* luxury-carousel.js
 * Arrow controls for the scroll-snap rails. Swipe is the control on touch;
 * this only drives the desktop buttons and keeps their disabled state
 * honest so nobody clicks into a dead end.
 */
(function () {
  'use strict';

  function setup(rail) {
    var section = rail.closest('section');
    if (!section) return;
    var prev = section.querySelector('[data-rail-prev]');
    var next = section.querySelector('[data-rail-next]');
    if (!prev || !next) return;

    function step() {
      var first = rail.firstElementChild;
      if (!first) return rail.clientWidth;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
    }

    prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });

    var ticking = false;
    rail.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { sync(); ticking = false; });
    }, { passive: true });

    window.addEventListener('resize', sync);
    sync();
  }

  function init() {
    var rails = document.querySelectorAll('[data-rail]');
    Array.prototype.forEach.call(rails, setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-bind when the theme editor swaps a section in.
  document.addEventListener('shopify:section:load', init);
})();
